import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpRequest } from '@angular/common/http';
import * as TyreRepairOrderModels from '../../models/tyre-repair-order/tyre-repair-order';
import { TyreRepairOrderSearchModel } from '../../models/tyre-repair-order/tyre-repair-orderSearch';
import { EnvironmentService } from '../../../app/services/environment.service';
import * as OrderStatusModels from '../../models/order/orderStatus';
import * as Models from '../../models/commonModels';

@Injectable({
  providedIn: 'root'
})

export class TyreRepairOrderService {

  constructor(private httpClient: HttpClient,
    private environmentService: EnvironmentService) { }

  public getList(Search: TyreRepairOrderSearchModel) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    Search.RequestSignature = Math.random();

    const options = { headers: httpHeaders };

    return this.httpClient.post<TyreRepairOrderModels.TyreRepairOrderListModel>(`${this.environmentService.getApiURL()}/tyre-repair-order/list`, Search, options);
  }

  public getStatusDictionary() {
    return this.httpClient.get<OrderStatusModels.OrderStatusListModel>(`${this.environmentService.getApiURL()}/tyre-repair-order/status`);
  }

  public set(TyreReturnOrder: Models.Request<TyreRepairOrderModels.TyreRepairOrderModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<TyreRepairOrderModels.TyreRepairOrderModel>>(`${this.environmentService.getApiURL()}/tyre-repair-order/set`, TyreReturnOrder, options);
  }

  public get(TyreReturnOrder: Models.RequestModel) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<TyreRepairOrderModels.TyreRepairOrderModel>>(`${this.environmentService.getApiURL()}/tyre-repair-order/get`, TyreReturnOrder, options);
  }

  public create(TyreReturnOrder: Models.RequestNewOrder<TyreRepairOrderModels.TyreRepairOrderModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<TyreRepairOrderModels.TyreRepairOrderModel>>(`${this.environmentService.getApiURL()}/tyre-repair-order/create`, TyreReturnOrder, options);
  }
}
